import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { motion } from "framer-motion";
import { useState } from "react";
import {  httpsCallable } from "firebase/functions";
import NavbarSection from "../components/NavbarSection";
import FooterSection from "../components/FooterSection";
import { functions } from "../firebase";

const Support = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setAlert({ show: false, type: "", message: "" });

    if(!formData.name){
      console.log("Name required");
      return
    }  
    if(!formData.email){
      console.log("Name required");
      return
    }  
    if(!formData.message){
      console.log("Name required");
      return
    }
    try {
      
      // Get the callable function
      const sendSupportEmail = httpsCallable(functions, 'sendSupportEmail');
      console.log("Sending email with data:", formData);
      // Call the function with form data
      const result = await sendSupportEmail({
        name: formData.name,
        email: formData.email,
        message: formData.message
      });

      // Check if successful
      if (result.data.success) {
        setAlert({
          show: true,
          type: "success",
          message: "Thank you for contacting us! We'll get back to you soon."
        });
        // Reset form
        setFormData({ name: "", email: "", message: "" });
      } else {
        throw new Error(result.data.message || "Failed to send message");
      }
    } catch (error) {
      console.error('Error sending email:', error);
      
      // Handle specific Firebase error codes
      let errorMessage = "An error occurred. Please try again or email us directly at support@writeoffgenie.ai";
      
      if (error.code === 'functions/invalid-argument') {
        errorMessage = error.message;
      } else if (error.code === 'functions/unauthenticated') {
        errorMessage = "Authentication required. Please refresh the page and try again.";
      } else if (error.code === 'functions/internal') {
        errorMessage = "Server error. Please try again later.";
      }
      
      setAlert({
        show: true,
        type: "danger",
        message: errorMessage
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Navbar without vector background */}
      <div style={{
        backgroundColor: "#f0f0f0",
        paddingBottom: "20px"
      }}>
        <NavbarSection />
      </div>

      {/* Support Section */}
      <div style={{
        backgroundColor: "#f0f0f0",
        minHeight: "100vh",
        padding: "80px 0"
      }}>
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Row>
              {/* Left Column - Form */}
              <Col lg={6} md={12}>
                {alert.show && (
                  <Alert 
                    variant={alert.type} 
                    dismissible 
                    onClose={() => setAlert({ show: false, type: "", message: "" })}
                    style={{ borderRadius: "8px" }}
                  >
                    {alert.message}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  {/* Name and Email Row */}
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label style={{
                          color: "#4a4a4a",
                          fontSize: "0.95rem",
                          fontWeight: "400",
                          marginBottom: "8px"
                        }}>
                          Name *
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          placeholder="John Doe"
                          disabled={isSubmitting}
                          style={{
                            backgroundColor: "#d4d4d4",
                            border: "none",
                            borderRadius: "8px",
                            padding: "12px 16px",
                            fontSize: "1rem"
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label style={{
                          color: "#4a4a4a",
                          fontSize: "0.95rem",
                          fontWeight: "400",
                          marginBottom: "8px"
                        }}>
                          Email *
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          placeholder="john@example.com"
                          disabled={isSubmitting}
                          style={{
                            backgroundColor: "#d4d4d4",
                            border: "none",
                            borderRadius: "8px",
                            padding: "12px 16px",
                            fontSize: "1rem"
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Message Field */}
                  <Form.Group className="mb-4">
                    <Form.Label style={{
                      color: "#4a4a4a",
                      fontSize: "0.95rem",
                      fontWeight: "400",
                      marginBottom: "8px"
                    }}>
                      Message *
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={6}
                      placeholder="How can we help you?"
                      disabled={isSubmitting}
                      maxLength={5000}
                      style={{
                        backgroundColor: "#d4d4d4",
                        border: "none",
                        borderRadius: "8px",
                        padding: "12px 16px",
                        fontSize: "1rem",
                        resize: "none"
                      }}
                    />
                    <Form.Text style={{ color: "#666", fontSize: "0.85rem" }}>
                      {formData.message.length}/5000 characters
                    </Form.Text>
                  </Form.Group>

                  {/* Submit Button */}
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    style={{
                      backgroundColor: "#1a1a2e",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px 40px",
                      fontSize: "1rem",
                      fontWeight: "400",
                      color: "#fff",
                      opacity: isSubmitting ? 0.7 : 1,
                      cursor: isSubmitting ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      if (!isSubmitting) {
                        e.target.style.backgroundColor = "#2a2a3e";
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#1a1a2e";
                    }}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </Button>

                  {/* reCAPTCHA Notice */}
                  <div className="mt-4" style={{ fontSize: "0.85rem", color: "#666" }}>
                    <p className="mb-1">
                      This site is protected by reCAPTCHA and the Google{" "}
                      <a
                        href="https://policies.google.com/privacy"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: "#1a1a2e",
                          textDecoration: "underline",
                          fontWeight: "600"
                        }}
                      >
                        Privacy Policy
                      </a>
                    </p>
                    <p className="mb-0">
                      and{" "}
                      <a
                        href="https://policies.google.com/terms"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: "#1a1a2e",
                          textDecoration: "underline",
                          fontWeight: "600"
                        }}
                      >
                        Terms of Service
                      </a>{" "}
                      apply.
                    </p>
                  </div>

                  {/* Account Closure Link */}
                  <div className="mt-5 pt-5">
                    <a
                      href="/delete-account"
                      style={{
                        color: "#1a1a2e",
                        textDecoration: "underline",
                        fontSize: "1rem",
                        fontWeight:"500"
                      }}
                    >
                      Need to permanently close your account?
                    </a>
                  </div>
                </Form>
              </Col>

              {/* Right Column - Support Info */}
              <Col lg={6} md={12} className="ps-lg-5">
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="mt-5 mt-lg-0"
                >
                  <h1 style={{
                    fontSize: "3.5rem",
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem",
                    lineHeight: "1.2"
                  }}>
                    Support
                  </h1>
                  <p style={{
                    fontSize: "1.05rem",
                    color: "#4a4a4a",
                    lineHeight: "1.7"
                  }}>
                    Need assistance with WriteOffGenie? Fill out the form or contact us at{" "}
                    <a
                      href="mailto:Support@writeoffgenie.ai"
                      style={{
                        color: "#08a040ff",
                        textDecoration: "none",
                        fontWeight: "400"
                      }}
                    >
                      Support@writeoffgenie.ai
                    </a>
                  </p>
                </motion.div>
              </Col>
            </Row>
          </motion.div>
        </Container>
      </div>

      <FooterSection />
    </>
  );
};

export default Support;